import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../lib/api'

export default function ResetPasswordRequest() {
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [requested, setRequested] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api('/patient-auth/password-reset/request', {
        method: 'POST',
        body: JSON.stringify({ email }),
      })
      // Always the same message regardless of whether the email matched an
      // account — the backend never reveals that either, and now always
      // sends the reset link by email rather than returning it here.
      setRequested(true)
    } catch {
      setError('Something went wrong. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-shell warm-theme">
      <div className="auth-card">
        <h1>Reset your password</h1>
        {!requested ? (
          <form onSubmit={submit}>
            <div className="field"><label>Email</label><input className="inp" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus /></div>
            {error && <div className="form-error" role="alert">{error}</div>}
            <button className="btn full" type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send reset link'}</button>
          </form>
        ) : (
          <p className="muted" style={{ fontSize: 13.5 }}>
            If an account exists for this email address, we've sent password reset instructions.
          </p>
        )}
        <p className="muted" style={{ fontSize: 13, marginTop: 16 }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
